import React from "react";
import { useUIStore } from "@store";
import styles from "./ChatBubble.module.css";
import { SparkleIcon, ArrowForwardIcon } from "../common/Icons";
import { useAuthStore } from "@store";
import { initializeChatData } from "../../App";
import { logDebug } from "../../utils/logging";
import { trackEvent } from "../../services/analyticsService";

const ChatBubble: React.FC = () => {
  const openChatToSidebar = useUIStore((state) => state.openChatToSidebar);
  const setIsInitializingChat = useUIStore(
    (state) => state.setIsInitializingChat,
  );
  const isLoadingInitialData = useAuthStore(
    (state) => state.isLoadingInitialData,
  );
  const initialDataLoaded = useAuthStore((state) => !!state.jwt);

  const setLoadingInitialData = useAuthStore(
    (state) => state.setLoadingInitialData,
  );
  const setInitialData = useAuthStore((state) => state.setInitialData);
  const setInitialDataError = useAuthStore(
    (state) => state.setInitialDataError,
  );

  const handleOpenChat = async () => {
    // Track widget open event once per session
    const hasTrackedOpen = sessionStorage.getItem("smartieWidgetOpened");
    if (!hasTrackedOpen) {
      trackEvent("widget_opened", {
        source: "chat_pill"
      });
      sessionStorage.setItem("smartieWidgetOpened", "true");
    }

    if (isLoadingInitialData) {
      logDebug("Chat bubble clicked. Initial data is already loading.");
      return;
    }

    if (initialDataLoaded) {
      logDebug(
        "Chat bubble clicked. Initial data already loaded. Opening to sidebar.",
      );
      openChatToSidebar();
      return;
    }

    logDebug(
      "Chat bubble clicked. Setting initializing state and opening sidebar...",
    );
    setIsInitializingChat(true);
    openChatToSidebar();

    logDebug("Chat bubble: Now attempting to initialize chat data...");
    await initializeChatData(
      setLoadingInitialData,
      setInitialData,
      setInitialDataError,
    );

    logDebug(
      "Chat bubble: Chat data initialization complete. Clearing initializing flag.",
    );
    setIsInitializingChat(false);
  };

  return (
    <div className={styles.widgetContainer}>
      <button
        onClick={handleOpenChat}
        className={styles.chatBubblePill}
        aria-label="Deschide widgetul de chat"
        title="Deschide widgetul de chat"
      >
        <div className={styles.iconWrapper}>
          <div className={styles.pingAnimation} />
          <SparkleIcon className={styles.icon} />
        </div>
        
        <div className={styles.textWrapper}>
          <span className={styles.title}>Ai nevoie de ajutor?</span>
          <span className={styles.subtitle}>Începe o conversație</span>
        </div>
        
        <div className={styles.arrowWrapper}>
          <ArrowForwardIcon className={styles.arrowIcon} />
        </div>
      </button>
    </div>
  );
};

export default ChatBubble;
